import * as React from 'react';
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import SettingsIcon from "@mui/icons-material/Settings";
import ProfileMenu from "../menu/ProfileMenu";
import {makeStyles} from "@material-ui/core/styles";
import SLogo from "../../assets/images/SLogo.png";
import DashboardIcon from '@mui/icons-material/Dashboard';
import {useContext} from "react";
import {useHistory} from "react-router-dom";
import MasterContext from "../../context/MasterContext";
import GroupIcon from '@mui/icons-material/Group';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import Tooltip from '@mui/material/Tooltip';
import SancorS from '../../assets/images/SancorS.png';

import ByPolko from "../../components/customer/ByPolko";
import UserContext from "../../context/UserContext";


const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(9)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(
    ({theme, open}) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const useStyles = makeStyles((theme) => ({
    nombreMenu: {
        fontSize: '16px',
        color: '#f3f4f8',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
    },
    imagenPerfil: {
        width: '48px', height: '48px', borderRadius: '50%',
        border: '2px solid #fff',
        margin: '0 10px',
        [theme.breakpoints.down('md')]: {
            margin: 0
        },
    },
    sancorLogo: {
        width: " auto",
        height: "50px",
    },
    sancorLogoS: {
        width: " auto",
        height: "32px",
    },
    navBar: {
        position: "relative",
        backgroundColor: "#004285",
        clippath: "polygon(0 0, 100% 0, 100% 70px, 0 70px)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        height: "70px",
    },
    navBarUserInfo: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginRight: "20px",
        width: "100%",
    },
    divByPolko: {
        width: '70px',
        marginBottom: "48px",
        position: "absolute",
        bottom: 0,
        height: "104px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    navBarUserInfoDivider: {
        transform: "rotate(90deg)",
        color: "#fff",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    navBarUserInfoNameRole: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "self-end"
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        //this will hide the backdrop when varient="temporary"
        "& .MuiBackdrop-root": {
            display: "none"
        }
        //backgroundColor: "rgba(0,0,0,0.6)" Don't target this
    },
    drawerPaper: {
        width: "240px   ",
        backgroundColor: "rgba(120,120,120,0.2)"
    },
    drawerHeader: {
        backgroundColor: "#4C5782"
    },
    toolbar: {
        backgroundColor: "#3D4977"
    },
    itemList: {
        margin:"4px 0px",
        '&:hover': {
            borderRadius: "0px 30px 30px 0px",
        },
    },
    itemListIcon: {
        paddingLeft: "8px"
    },
    sidebarLayout: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
    }
}));

export default function SideNavBarMUI(props) {
    const classes = useStyles();
    const {userName, userPicture} = useContext(UserContext);
    const {open, togleSideNav} = useContext(MasterContext);
    const role = props.role;
    const history = useHistory();

    const itemsSideBarTexts = [
        "Dashboard",
        'Gestionar Afinidades',
        'Agregar Afinidad',
        'Configuración',
    ];
    const itemsSideBarIcons = [
        <Tooltip title="Dashboard" placement="right"><DashboardIcon style={{color: "#3D4977"}}/></Tooltip>,
        <Tooltip title="Gestionar Afinidades" placement="right"><GroupIcon style={{color: "#3D4977"}}/></Tooltip>,
        <Tooltip title="Agregar Afinidades" placement="right"><GroupAddIcon style={{color: "#3D4977"}}/></Tooltip>,
        <Tooltip title="Configuración" placement="right"><SettingsIcon style={{color: "#3D4977"}}/></Tooltip>
    ];

    const handleItemClick = (idx) => {
        switch (idx) {
            case 0:
                history.push("/u/m/dashboard");
                break;
            case 1:
                history.push("/u/m/afinidades");
                break;
            case 2:
                history.push("/u/m/new-affinity");
                break;
            case 3:
                history.push("/u/m/configuration");
                break;
        }
    }

    const handleDrawerOpen = () => {
        togleSideNav();
    };
    const handleDrawerClose = () => {
        togleSideNav();
    };

    const displaySidebarItems = () => {
        let finalItems = []

        finalItems.push(
            <>
                {itemsSideBarTexts.map((text, index) => {
                    if (index !== itemsSideBarTexts.length - 1) {
                        return (
                            <ListItem button key={text} onClick={() => handleItemClick(index)}
                                      className={classes.itemList}>
                                <ListItemIcon className={classes.itemListIcon}>
                                    {itemsSideBarIcons[index]}
                                </ListItemIcon>
                                <ListItemText primary={text}/>
                            </ListItem>
                        )
                    }
                })}
            </>
        )

        //Last item with marginTop: auto to locate itself at the bottom
        finalItems.push(
            <ListItem button key={itemsSideBarTexts[itemsSideBarTexts.length - 1]}
                      onClick={() => handleItemClick(itemsSideBarTexts.length - 1)}
                      className={classes.itemList} style={{marginTop: "auto"}}>
                <ListItemIcon className={classes.itemListIcon}>
                    {itemsSideBarIcons[itemsSideBarTexts.length - 1]}
                </ListItemIcon>
                <ListItemText primary={itemsSideBarTexts[itemsSideBarTexts.length - 1]}/>
            </ListItem>
        )

        return finalItems;
    }

    return (
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>
            <AppBar position="fixed" open={open}>
                <Toolbar className={classes.toolbar}>
                    <img
                        className={classes.sancorLogoS}
                        src={SancorS}
                        alt="SLogo"
                        hidden={open}
                        style={{marginRight: "16px", marginLeft: "-8px",}}
                    />
                    <Divider orientation="vertical" flexItem style={{margin: "0px 16px 0px 8px"}} hidden={open}/>
                    <Tooltip title="Expandir" placement="right" hidden={open}>
                        <IconButton
                            color="inherit"
                            style={{color: "#fff", display: open && "none"}}
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                        >
                            <MenuIcon/>
                        </IconButton>
                    </Tooltip>
                    <div className={classes.navBarUserInfo}>
                        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <NotificationsNoneIcon style={{fill: "#fff"}}/>
                        </div>
                        <div className={classes.navBarUserInfoDivider}>
                            <HorizontalRuleIcon/>
                        </div>

                        <div className={classes.navBarUserInfoNameRole}>
                            <p className="adviser-name">{userName}</p>
                            <p className="adviser-position" style={{marginTop: "0px"}}>{role}</p>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <ProfileMenu
                                userImg={userPicture}/>
                        </div>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                open={open}
            >
                <DrawerHeader className={classes.drawerHeader}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                    }}>
                        <img
                            className={classes.sancorLogo}
                            src={SLogo}
                            alt="SLogo"

                        />
                        <IconButton onClick={handleDrawerClose}>
                            <Tooltip title="Colapsar" placement="right-start">
                                <ChevronLeftIcon style={{color: "#fff"}}/>
                            </Tooltip>
                        </IconButton>
                    </div>
                </DrawerHeader>
                <Divider/>
                <List style={{
                    height: "100%",
                    //From divByPolko 104px height + 48px marginBottom
                    marginBottom: "152px"}}
                >
                    <div className={classes.sidebarLayout}>
                        {displaySidebarItems()}
                    </div>
                </List>

                <div className={classes.divByPolko}>
                    <ByPolko fontSize={16}/>
                </div>
            </Drawer>
        </Box>
    );
}